import React from "react";
import { Box } from "@mui/material";
import { ensureNamespacesLoadedSync } from "../../i18n/lazyNamespaces";
import TeamSalesPipelineRoutes from "../SalesPipeline/TeamSalesPipelineRoutes";
import { POPUP_TEAM_BASE } from "../../utils/teamNavigation";

ensureNamespacesLoadedSync(["team", "teamTasks", "teamAgenda"]);

const SalesPipelinePopup = () => (
  <Box
    sx={{
      height: "100vh",
      width: "100vw",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      bgcolor: "background.default",
    }}
  >
    <TeamSalesPipelineRoutes basePath={POPUP_TEAM_BASE} standalone />
  </Box>
);

export default SalesPipelinePopup;
